export default {
  placeholder: 'Vybrať stavy zákazky',
};
